import { AfterContentInit, Component, EventEmitter, ViewEncapsulation } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import jQuery from "jquery";
import _ from "lodash";
import { BehaviorSubject } from "rxjs";
import { AlertService } from "src/app/services/alert.service";
import { IProgress } from "src/app/services/api.service";
import { AuthService } from "src/app/services/auth.service";
import { LoaderService } from "src/app/services/loader.service";
import { environment } from "src/environments/environment";
import { AbstractSplitView } from "../abstract-split-view/abstract-split-view";
import { ProofreadingService } from "src/app/services/proofreading.service";
import { LivecoAPIService } from "src/app/services/liveco-api.service";
import { StateMachineService } from "src/app/services/machine-state.service";
import { ProjectService } from "src/app/services/project.service";
import { MembersService } from "src/app/services/member.service";
import { TranslateService } from "@ngx-translate/core";
import { MarqueService } from "src/app/services/marque.service";

// @ts-ignore
// const api = require("@modules/cf-api.js").api;
// const api_async = require("@modules/cf-api.js").api_async;

@Component({
    selector: "app-split-view-old",
    templateUrl: "./split-view-old.page.html",
    styleUrls: ["./split-view-old.page.scss"],
    encapsulation: ViewEncapsulation.None
})
export class SplitViewOldComponent extends AbstractSplitView {
    // STRUCTURE
    public viewLink: BehaviorSubject<string | null> = new BehaviorSubject<string | null>("");

    languages: string[] = [];
    // history: any;
    // fields: any;
    job: any;
    open: boolean;
    open2: boolean = true;

    showFiller = false;
    fields: any;
    currentLang: string = "fr";
    fieldsCustom: { [key: string]: any; } = {};

    public progress: EventEmitter<IProgress> = new EventEmitter<IProgress>();
    public loadRendering: boolean = false;

    getProperty(lang: string) {
        return Object.keys(this.fields[lang]);
    }

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected sanitizer: DomSanitizer,
        protected s_alert: AlertService,
        protected dialog: MatDialog,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected prService: ProofreadingService,
        protected title: Title,
        protected liveco: LivecoAPIService,
        protected s_sm: StateMachineService,
        protected s_proofreadings: ProofreadingService,
        protected s_projects: ProjectService,
        protected s_members: MembersService,
        protected translate: TranslateService,
        protected s_marques: MarqueService
        
    ) {
        super(title, route, router, s_alert, s_loader, s_auth, liveco, s_sm, s_proofreadings, s_projects, s_members, sanitizer, s_marques);
    }

    ngAfterViewChecked(): void {
        this.open = true;
    }

    async retrieveData() {
        const iframe = document.getElementById('content') as HTMLIFrameElement;
        iframe.classList.remove('splitviewFullScreen');
        this.route.params.subscribe(async params => {
            const projectId = params['id']; // Access the parameter 'id' from the URL

            if (projectId) {
                const project = await this.liveco.get(projectId, "/project");

                if (project) {
                    const response = project;

                    console.log('viewLink', environment.cfURL + response.custom.general.true_url);
                    this.viewLink.next(environment.cfURL + response.custom.general.true_url);

                    if (this.viewLink.getValue() !== environment.cfURL) {
                        jQuery("#viewLink").attr("src", this.viewLink.getValue());
                    } else {
                        jQuery("#viewLink").attr("src", "");
                    }
                }

                this.onDataRecieved.bind(this);
            }
        });
    }
}
